import Gallery from "./screens/Gallery"
import Location from "./screens/Location"
import Specification from "./screens/Specification"
import ShowApartment from "./screens/ShowApartment"
import Favourites from "./screens/Favourites"
import AboutUs from "./screens/AboutUs"
import Overview from "./screens/Overview"

import SetVis from "./components/ApartmentFinder/Components/SetVis"

export const primaryRoutes = [
  {
    name: "Location",
    path: "/location",
    component: Location
  },
  {
    name: "Explore",
    path: "/overview",
    component: Overview
  },
  {
    name: "Apartment Finder",
    path: "/finder",
    component: SetVis
  },
  {
    name: "Show Apartment",
    path: "/show-apartment",
    component: ShowApartment
  },
  {
    name: "Options and Specification",
    path: "/specification",
    component: Specification
  },
  {
    name: "Gallery",
    path: "/gallery",
    component: Gallery
  },
  {
    name: "favourites",
    path: "/favourites",
    component: Favourites
  },
  {
    name: "About Us",
    path: "/aboutus",
    component: AboutUs
  }
]

export const AboutPath = primaryRoutes[7].path

export const home = primaryRoutes[0]
